// 세션 만료 안내 다이얼로그 — 만료 시 로그인 화면 위에 뜨고, 확인을 누르면 닫힌다
import React from 'react';
import { AXButton, AXModal } from 'yukimushi-component-fe';
import { useAuth } from '../context/AuthContext';

export default function SessionExpiredDialog() {
  const { sessionExpired, dismissSessionExpired } = useAuth();

  return (
    <AXModal
      open={sessionExpired}
      onClose={dismissSessionExpired}
      title="토큰이 만료되었습니다."
      width={420}
      footer={
        <AXButton variant="primary" onClick={dismissSessionExpired}>
          확인
        </AXButton>
      }
    >
      다시 로그인 해주세요.
    </AXModal>
  );
}
